import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {HeroIntroPanel} from "@/scenes.ui.clan/hero-intro-panel";

export class MythIntroPanel extends HeroIntroPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement) {
        super(scene, canvas, Tr('myth.her'), Tr('myth.ava'), Tr('too.many.her'), Tr('myth.are.cool'));
    }

    protected onClose(): void {

    }

}
